const FAQS = [
  {
    q: '白云视频真的完全免费吗？需要注册会员吗？',
    a: '是的，白云视频所有影视内容均免费提供，无需注册会员、无需付费即可在线观看。我们致力于打造最开放的免费影视平台，让每位用户都能零门槛享受高清观影体验。',
  },
  {
    q: '白云视频和西瓜视频免费版有什么区别？',
    a: '白云视频提供与西瓜视频同类型的在线看剧体验，同样支持高清播放、每日更新。白云视频拥有独立的片库和推荐算法，在某些内容覆盖和播放策略上各有特色，为用户提供了西瓜视频之外的优质免费观影选择。',
  },
  {
    q: '播放视频时卡顿怎么办？',
    a: '白云视频采用多线路智能切换技术。如果遇到卡顿，可以尝试切换播放线路（点击播放器右下角的线路切换按钮），或降低清晰度以获得更流畅的播放体验。我们也在持续优化服务器网络，确保高峰时段稳定播放。',
  },
  {
    q: '可以在手机上观看白云视频吗？',
    a: '当然可以！白云视频已针对移动端进行全面适配优化，支持iOS和Android手机浏览器直接访问。您也可以下载白云视频APP（见页面"移动观影"区域），获得更便捷的手机观影体验，支持离线缓存和投屏功能。',
  },
  {
    q: '片库更新频率是怎样的？最新影视资源多久上线？',
    a: '白云视频片库每日更新，热播电视剧通常在播出后24小时内上线，热门电影也会在院线下映后尽快收录。我们设有专门的更新团队，第一时间为用户带来最新影视内容，让您追剧无需等待。',
  },
  {
    q: '白云视频上可以看哪些类型的影视内容？',
    a: '白云视频覆盖电影、电视剧、综艺、动漫、纪录片五大核心品类，包含国产、港台、日韩、欧美等区域内容。无论是热门大片、经典老片、热播连续剧还是人气动漫，在白云视频几乎都能找到。',
  },
];

import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-3">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          为您解答关于白云视频的常见疑问
        </p>
        <div className="flex flex-col gap-3">
          {FAQS.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-50/80 transition-colors"
                onClick={() => setOpenIndex(openIndex === i ? -1 : i)}
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <div className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full transition-colors ${
                  openIndex === i ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className={`ri-${openIndex === i ? 'subtract' : 'add'}-line text-sm`}></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}